import { render } from "./ImportOldOppOverviewNote.vue?vue&type=template&id=3aa763b6&scoped=true"
import script from "./ImportOldOppOverviewNote.vue?vue&type=script&lang=js"
export * from "./ImportOldOppOverviewNote.vue?vue&type=script&lang=js"

import "./ImportOldOppOverviewNote.vue?vue&type=style&index=0&id=3aa763b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa763b6"]])

export default __exports__